export default __webpack_public_path__ + "static/media/jewish-1.b7c11117.jpg";